@if (showDot()) {
  <div class="ring-container position-{{ position }}">
    <div class="ringring"></div>
    <div class="circle"></div>
  </div>
}
